import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import SkeletonElement from "../common/SkeletonElement";
import { EmptyComponent } from "../common/EmptyComponent";

const LoyaltySkeletonWrapper = styled.div`
  background: rgb(35, 35, 35);
  border-radius: 4px;
  height: 4.5rem;
  width: ${props => (props.isMobile ? "100%" : "20rem")};
`;

const LoyaltySkeletonSection = styled.div`
  padding: 1rem;
`;

const LoyaltyContentSkeleton = props => {
  const { isLoaded, isMobile } = props;

  return (
    <>
      {!isLoaded ? (
        <LoyaltySkeletonWrapper isMobile={isMobile}>
          <LoyaltySkeletonSection>
            <SkeletonElement
              width={"100%"}
              height={"1rem"}
              margin={"0.7rem 0"}
            />
          </LoyaltySkeletonSection>
        </LoyaltySkeletonWrapper>
      ) : (
        <EmptyComponent />
      )}
    </>
  );
};

LoyaltyContentSkeleton.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default React.memo(LoyaltyContentSkeleton);
